<button type="button" [matMenuTriggerFor]="menu" mat-button="">
  <craft-user-icon [user]="user"></craft-user-icon>
</button>

<mat-menu #menu="matMenu" class="account-popup">
  <ng-template matMenuContent="">
    <button type="button" class="account-wrap d-flex align-items-center">
      <div class="account-logo d-flex align-items-center">
        <craft-user-icon class="d-flex shrink-0 mr-20" [user]="user"></craft-user-icon>
        <div class="account-data">
          <div [matTooltip]="user | fullName" matTooltipPosition="above" class="account-author ellipsis">
            {{ user | fullName }}
          </div>

          <div [matTooltip]="user?.email || ''" matTooltipPosition="above" class="account-email ellipsis">
            {{ user?.email }}
          </div>
        </div>
      </div>
    </button>

    <a [routerLink]="['/profile', 'notifications']" mat-menu-item="" class="text-size-13"> Notification Settings </a>
    <button type="button" mat-menu-item="" (click)="logout()">LOG OUT</button>
  </ng-template>
</mat-menu>
